import {
  requestPublic,
  request
} from './request.js'

// 获取学生住宿安排
export function GetMyAgreementRerords() {
  return request({
      url: '/api2/StudentAccommodationApi/AgreementRecordWeb/GetMyAgreementRerords',
      method: 'get',
  })
}
// 获取pdf文件流
export function GetAgreementPDFStream(id) {
  return request({
      url: '/api2/StudentAccommodationApi/AgreementRecordWeb/GetAgreementPDFStream',
      method: 'get',
      responseType: 'blob',
      headers: {
        // 'Content-Type': 'application/pdf'
              'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
      params:{
        id
      }
  })
}
// 签订协议postAgreement

// 获取pdf文件流
export function postAgreement(obj) {
  console.log(obj.id)
  return request({
      url: '/api2/StudentAccommodationApi/AgreementRecordWeb/SignAgreement',
      method: 'post',
      data:{
        id:obj.id,
        imgUrl:obj.imgUrl,
      }
  })
}

// 学员身份校验
// 获取pdf文件流
export function CheckSignIDCard(obj) {
  console.log(obj.id)
  return request({
      url: '/api2/StudentAccommodationApi/AgreementRecordWeb/CheckSignIDCard',
      method: 'get',
      params:{
        agreementRecordId:obj.agreementRecordId,
        studentName:obj.studentName,
        idCard:obj.idCard,
      }
  })
}
// 协议详情
export function GetAgreementRerordDetail(agreementRecordId) {
  return request({
      url: '/api2/StudentAccommodationApi/AgreementRecordWeb/GetAgreementRerordDetail',
      method: 'get',
      params:{
        agreementRecordId:agreementRecordId,
      }
  })
}